// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3Ggv2","header":"style_header__3u9-H"};